export default __webpack_public_path__ + "static/media/tamsat.fae4587e.png";